import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { IntroductionButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';
import Introduction from '@Components/Introduction';

import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { MarketingIndustryFormValues } from '../NatureOfBusinessFormProvider/types';

export const MARKET_LAST_YEAR_INTRODUCTION_ID = 'market-last-year-introduction';

const MarketPolicyLastYearIntroduction = () => {
  const { control, getValues } = useNatureOfBusinessForm();

  const { marketingPolicyIntroduction: introduction } =
    getValues(`marketingIndustry`) ?? ({} as MarketingIndustryFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const marketLastYearIntroductionEl = document.getElementById(
    MARKET_LAST_YEAR_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'marketingIndustry',
      control,
    }) ?? ({} as MarketingIndustryFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        marketLastYearIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="นโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมา"
              setOpen={open}
              fieldPath="marketingIndustry.marketingPolicyIntroduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          marketLastYearIntroductionEl
        )}
    </>
  );
};

export default MarketPolicyLastYearIntroduction;
